var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-map__results"},[_c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100vh"},attrs:{"center":_vm.center,"zoom":8,"options":{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: true,
            fullscreenControl: false,
            disableDefaultUi: false,
            scrollwheel: true,
            styles: _vm.mapStyle,
            maxZoom: 30
        }}},[_c('gmap-info-window',{ref:"infoWindow",attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen = false}}},[(_vm.render)?_c('activities-map-slider',{ref:"activitiesMapSlider",attrs:{"activities":_vm.currentActivities}}):_vm._e()],1),_vm._l((_vm.activities),function(marker,index){return _c('GmapMarker',{key:index,ref:"marker",refInFor:true,attrs:{"clickable":true,"name":marker.providerName,"label":{
                text: marker.amountOfActivitiesOnThisLocation,
                color: 'white',
                fontWeight: 'bold'
            },"position":{
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.long)
            },"center":{
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.long)
            },"icon":{
                url: '/Content/img/pin-purple.png',
                color: 'yellow',
                labelOrigin: { x: 19, y: 22 }
            }},on:{"click":function($event){return _vm.toggleInfoWindow(marker, index)}}})})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }